import { CCol, CInput, CLabel, CRow, CTextarea } from "@coreui/react";
import React, { useEffect, useState } from "react";
import { apiCall, apiCallSPPost } from "src/_apiConfig/apiCall";
import Auth from "src/auth";
import { updateSearchStatus } from "src/views/common/CommonSearch";
import CustomeModalPopup from "src/views/common/CustomeModalPopup";

const RevertEntry = (props) => {
  useEffect(() => {
    if (props.showModal === true) {
      setReverseEntry({ ...reverseEntry, ...ReverseEntryModel });
    }
  }, [props.showModal]);
  const { authenticated } = Auth();
  const ReverseEntryModel = {
    lotPaymentId: 0,
    comment: "",
    approvalDate: "",
    approvalSupportFilePath: "",
    approvalSupportSelectedFile: "",
  };
  // Search Model
  const [reverseEntry, setReverseEntry] = useState(ReverseEntryModel);

  const [ApprovalDocumentSelectedFile, setApprovalDocumentSelectedFile] =
    useState();
  const [ApprovalDocumentFileEvent, setApprovalDocumentFileEvent] =
    useState(false);

  const handleClose = (event, reason) => {
    console.log("reason : ", reason);
    if (reason === "escapeKeyDown") {
      console.log("ddd", "escapeKeyDown");
    }
    if (reason === "backdropClick") {
      console.log("ddd", "backdropClick");
    }
    if (reason !== "backdropClick") {
      hideModal();
    }
  };
  const hideModal = () => props.setShowModal(false);
  // Search Model Value Update Manage
  const updateEntry = (e, name = "", value = "") => {
    updateSearchStatus(setReverseEntry, reverseEntry, e, name, value);
  };

  const SubmitConfirmation = async (e) => {
    e.preventDefault();
    //props.SetCPopUpButtonLodaer(true);
    props.setCPopUpIndex(-1);

    if (
      ApprovalDocumentSelectedFile === null ||
      ApprovalDocumentSelectedFile === undefined
    ) {
      alert("Please upload document in case you required tax concession");
    } else if (
      ApprovalDocumentSelectedFile != null &&
      ApprovalDocumentSelectedFile !== undefined &&
      ApprovalDocumentFileEvent !== null &&
      ApprovalDocumentFileEvent.target.files[0].type !== "application/pdf"
    ) {
      // let fileEvent = TaxConsessionFileEvent;
      // if (fileEvent.target.files[0].type !== "application/pdf") {
      alert("Please Upload Only pdf file!");
      // }
    } else {
      handleReverseEntry(props.lotPaymentId);
    }
    //handleReverseEntry(lotPaymentId, reverseSubTypeId, iTConcessionPer);
  };

  const setGetReverseSubTypeId = async (ReverseSubTypeId) => {
    console.log("setGetReverseSubTypeId : ", ReverseSubTypeId);
    switch (ReverseSubTypeId) {
      case 25:
        return 1;
      case 50:
        return 2;
      case 75:
        return 3;
      case 100:
        return 4;
      case -2:
        return 5;
      case -6:
        return 6;
      default:
        return null; // or another default value
    }
  };

  const handleReverseEntry = async (id) => {
    //e.preventDefault();

    // console.log("getReverseSubTypeId : ", getReverseSubTypeId);

    // console.log("authenticated : ", authenticated);
    if (authenticated) {
      let file = ApprovalDocumentSelectedFile;
      let filename = "";
      if (file !== null && file !== undefined) {
        filename = file.name;
      }

      let fileEvent = ApprovalDocumentFileEvent;
      if (
        fileEvent !== false &&
        fileEvent.target.files[0].type !== "application/pdf"
      ) {
        alert("Please Upload Only pdf file!");
      } else {
        let url = "";
        let data = "";
        const reverseTypeId = props.reverseTypeId;
        if (reverseTypeId === 1) {
          const getReverseSubTypeId = await setGetReverseSubTypeId(
            props.reverseSubTypeId
          );
          const data1 = {
            userId: authenticated.userId,
            lotPaymentId: id,
            taxConcessionPer: props.incomeTaxConcessionPercentage,
            isFullPayment: props.reverseSubTypeId === -2 ? true : false,
            reverseTypeId: 1,
            reverseSubTypeId: getReverseSubTypeId,
            isRequiredIncomeTaxConcession: true,
            additionalSDAmount: 0,
            isSDAmountPaidOnline: true,
            reverseEntryComment: reverseEntry.comment,
            approvalDate: reverseEntry.approvalDate,
            approvalSupportFilePath: filename,
            paymentTypeId: 0,
          };
          data = data1;
          url = "BackendActivity/ReverseEntry/Income_Tax_Concession_Reverse";
        } else if (props.reverseTypeId === 2) {
          const data2 = {
            userId: authenticated.userId,
            lotPaymentId: id,
            reverseTypeId: props.reverseTypeId,
            reverseSubTypeId: props.reverseSubTypeId,
            reverseEntryComment: reverseEntry.comment,
            approvalDate: reverseEntry.approvalDate,
            approvalSupportFilePath: filename,
            paymentTypeId: 0,
          };
          data = data2;
          url = "BackendActivity/ReverseEntry/ABS_Reverse";
        } else if (props.reverseTypeId === 3) {
          const data3 = {
            lotPaymentId: id,
            reverseTypeId: props.reverseTypeId,
            reverseSubTypeId: props.reverseSubTypeId,
            userId: authenticated.userId,
            reverseEntryComment: reverseEntry.comment,
            approvalDate: reverseEntry.approvalDate,
            approvalSupportFilePath: filename,
            paymentTypeId: 0,
          };
          data = data3;
          url = "BackendActivity/ReverseEntry/AdjustAmtFormDFO_Reverse";
        }

        console.log(data);

        await apiCallSPPost(url, JSON.stringify(data), 0)
          .then(async (res) => {
            if (res.success) {
              //            alert("done");

              //clearSearch(null);
              let etaxfileevent = ApprovalDocumentFileEvent;

              if (etaxfileevent !== false) {
                await SaveReverseDoc(res.data);
              } else {
                window.location.reload();
              }
            } else {
              alert("Error");
            }
          })
          .finally(() => {
            props.setloading(false);
          });
      }
    }
  };

  const SaveReverseDoc = async (ReverseEntryHistoryId) => {
    let fileEvent = ApprovalDocumentFileEvent;
    let file = ApprovalDocumentSelectedFile;
    if (fileEvent !== false) {
      if (authenticated) {
        if (fileEvent.target.files[0].type === "application/pdf") {
          // setSelectedFile(e.target.files[0]);
          //const files = fileEvent.target.files[0];
          const formData = new FormData();
          const header = new Headers();
          header.append("Accept", "application/json");

          formData.append("file", file);

          const url = `BackendActivity/ReverseEntry/UploadApprovalSupportDocument/${ReverseEntryHistoryId}/${props.reverseTypeId}`;
          console.log("dddd", url);
          const response = await apiCall(url, "POST", header, formData);

          const data1 = await response.text();
          console.log("dddd response", data1);

          if (response.status === 200) {
            //alert("Document Uploaded Successfully!");
            setApprovalDocumentSelectedFile();
            setApprovalDocumentFileEvent(false);
            alert("Rever Entry Submited Successfully");
            window.location.reload();
          } else {
            alert("Error to upload file!");
          }
        } else {
          alert("Please Upload Only pdf file!");
        }
      }
    }
  };

  const PopupTitle = (reverseTypeId) => {
    switch (reverseTypeId) {
      case 1:
        return "Income Tax Conecssion";
      case 2:
        return "Access Benift Sharing";
      case 3:
        return "Adjustment amount form DFO";
      default:
        return "";
    }
  };
  return (
    <CustomeModalPopup
      onOpen={props.showModal}
      onClose={handleClose}
      onSubmitButton={SubmitConfirmation}
      onCloseButton={handleClose}
      isSubmitBtnDisabled={false}
      isFromSubmit={true}
      popupWith={520}
      btnCColstyle={{ textAlign: "right" }}
      body={
        <>
          <CRow>
            <CCol>
              <CLabel>{PopupTitle(props.reverseTypeId)} - Revert Entry </CLabel>
            </CCol>
          </CRow>
          <hr />
          <CRow className="mb-3">
            <CCol>
              <CLabel>Comment * </CLabel>
              <CTextarea
                required
                name="comment"
                id="comment"
                rows="2"
                value={reverseEntry.comment}
                onChange={updateEntry}
                invalid={reverseEntry.comment === "" ? true : false}
              />
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol>
              <CLabel>Approval Date * :</CLabel>
              <CInput
                required
                type="date"
                placeholder=""
                id={"approvalDate"}
                name={"approvalDate"}
                value={reverseEntry.approvalDate}
                onChange={updateEntry}
                max={new Date().toISOString().split("T")[0]}
              />
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol>
              <CLabel>Approval Supporting Document * :</CLabel>
              <input
                required
                name="file"
                id="taxconsessiondoc"
                type="file"
                accept=".pdf"
                style={{ display: "inline", marginLeft: "20px" }}
                onChange={(e) => {
                  setApprovalDocumentFileEvent(e);
                  setApprovalDocumentSelectedFile(e.target.files[0]);
                  e.preventDefault();
                }}
              />
            </CCol>
          </CRow>
        </>
      }
    />
  );
};

export default RevertEntry;
